<template>
  <v-navigation-drawer
    :value="menuOpen"
    @input="(newValue) => $store.commit('MainTemplate/setMenuOpen', newValue)"
    color="grey lighten-5"
    app
  >
    <v-list-item class="px-2 py-5">
      <v-list-item-content>
        <v-list-item-title class="d-flex justify-center" id="menu.logo">
          <router-link :to="{ name: 'home' }">
            <img src="/img/logo.png" class="mb-5" width="100" />
          </router-link>
        </v-list-item-title>
        <v-list-item-subtitle class="d-flex justify-center" id="menu.ano_selector">
          <e-ano-selector class="" />
          <!-- <e-franquia-selector class="ml-2" /> -->
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list>
      <v-list-group
        v-for="item in menu.items.filter(
          (item) =>
            item.exibir && item.children.filter((child) => $can(child.permissions)).length > 0
        )"
        :key="item.title"
        v-model="item.active"
        no-action
        :append-icon="item.children && item.children.length > 0 ? undefined : ''"
        :prepend-icon="item.icon"
        @click="() => (item.to ? $router.push(item.to) : undefined)"
      >
        <template v-slot:activator>
          <!-- <v-list-item
                :to="item.to || undefined"
                link
              > -->
          <v-list-item-content>
            <v-list-item-title :id="item.id" v-text="item.title" />
          </v-list-item-content>
        </template>
        <v-list-item
          v-for="child in item.children"
          v-show="$can(child.permissions)"
          :key="child.title"
          :to="child.to"
          :href="child.href"
          :target="child.target"
        >
          <v-divider v-if="child.type === 'spacer'" />
          <v-list-item-content v-if="child.type !== 'spacer'">
            <v-list-item-title :id="child.id" v-text="child.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <!-- </v-list-group> -->
    <!-- </v-list> -->
    <template v-slot:append>
      <e-situacao-caixa v-if="exibirFinanceiro" />
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import EAnoSelector from "@/Pages/Templates/components/EAnoSelector.vue";
import ESituacaoCaixa from "@/Pages/Templates/components/ESituacaoCaixa.vue";

const exibirFinanceiro = process.env.VUE_APP_ATIVAR_FINANCEIRO === "true";
export default {
  name: "MainTemplate",
  components: {
    EAnoSelector,
    ESituacaoCaixa,
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquias"]),
    ...mapGetters("MainTemplate", ["menuOpen"]),
    menu() {
      return {
        items: [
          {
            id: "menu.inicio",
            icon: "fa fa-home",
            title: "Início",
            exibir: true,
            children: [
              {
                id: "menu.ir_para_inicio",
                title: "Ir para Início",
                to: {
                  name:
                    (this.user ? this.user.roleName : "") === "professor"
                      ? "acessoProfessor.home"
                      : "home",
                },
                icon: "",
              },
              {
                id: "menu.ir_para_notifiq",
                title: "Ir para notifiq",
                to: {
                  name: "notifiq.index",
                },
                permissions: ["notifiq.load"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.agenda",
            icon: "fa fa-book",
            title: "Agenda",
            exibir: (this.user ? this.user.roleName : "") === "aluno",
            children: [
              {
                id: "menu.ir_para_agendas",
                title: "Ir para Agendas",
                to: {
                  name: "agenda.aluno",
                },
                icon: "",
              },
            ],
          },
          {
            id: "menu.avisos",
            icon: "fa fa-warning",
            title: "Avisos",
            exibir: true,
            permissions: ["alunos.detalhes"],
            children: [
              // {
              //   title: "Meus avisos",
              //   to: {
              //     name: "avisos.portal",
              //   },
              //   icon: "",
              // },
              {
                id: "menu.ir_para_avisos",
                title: "Ir para Avisos",
                to: {
                  name:
                    (this.user ? this.user.roleName : "") === "aluno"
                      ? "avisos.portal"
                      : "avisos.index",
                },
                permissions: ["avisos.*", "avisos.listar", "alunos.detalhes"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.matriculas",
            icon: "fa fa-user-graduate",
            title: "Matrículas",
            exibir: true,
            children: [
              {
                id: "menu.ver_matriculas",
                title: "Ver Matrículas",
                to: { name: "matriculas" },
                permissions: ["matriculas.matricular", "matriculas.*"],
                icon: "",
              },
              // { title: "Adicionar matricula", to: "#", icon: "" },
              {
                id: "menu.ver_alunos",
                title: "Ver Alunos",
                to: { name: "alunos" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
              {
                id: "menu.pesquisa_avancada",
                title: "Pesquisa avançada",
                to: { name: "alunos-pesquisa-avancada" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.turmas",
            icon: "fa fa-graduation-cap",
            title: "Turmas",
            exibir: true,
            children: [
              {
                id: "menu.ver_turmas",
                title: "Ver turmas",
                to: { name: "turmas" },
                permissions: ["turmas.criarTurma", "turmas.*"],
                icon: "",
              },
              {
                id: "menu.gestao_anos",
                title: "Gestão de séries",
                to: { name: "series" },
                icon: "fa fa-bookmark",
                permissions: ["series.*", "series.criar"],
              },
              {
                id: "menu.gestao_disciplinas",
                title: "Gestão de disciplinas",
                to: { name: "disciplinas" },
                icon: "fa fa-bookmark",
                permissions: ["disciplinas.*", "disciplinas.criarDisciplina"],
              },
            ],
          },
          {
            id: "menu.diario_online",
            icon: "fa fa-chalkboard-teacher",
            title: "Diário online",
            exibir: true,
            children: [
              {
                id: "menu.diario_online.listar_todos",
                title: "Listar todos",
                to: { name: "gestoesDeAulas" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                id: "menu.diario_online.gestao_geral",
                title: "Gestão geral",
                to: { name: "gestoesDeAulas.geral" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.gestoesGeral"],
              },
              {
                id: "menu.diario_online.agendas",
                title: "Agendas",
                to: { name: "agenda.index" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.listar"],
              },
            ],
          },
          {
            id: "menu.relatorios",
            icon: "fa fa-file-pdf",
            title: "Relatórios",
            exibir: true,
            children: [
              {
                id: "menu.ver_todos_relatorios",
                title: "Ver todos",
                to: {
                  name: `relatorios`,
                  params: { franquiaId: this.user?.franquia.id ? this.user?.franquia.id : 0 },
                },
                icon: "",
                permissions: ["relatorios.*"],
              },
            ],
          },
          {
            id: "menu.usuarios",
            icon: "fa fa-users",
            title: "Usuários",
            exibir: true,
            children: [
              {
                id: "menu.ver_professores",
                title: "Ver Professores",
                to: { name: "professores" },
                icon: "fa fa-user-tie",
                permissions: ["users.*"],
              },
              {
                id: "menu.bloqueios_liberacoes",
                title: "Bloqueios/Liberações",
                to: { name: "usuarios.listaDeUsuariosParaBloquearLiberar" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
              {
                id: "menu.outros_usuarios",
                title: "Outros",
                to: { name: "usuarios" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
            ],
          },
          {
            id: "menu.financeiro",
            icon: "fa fa-money",
            title: "Financeiro",
            exibir: exibirFinanceiro,
            children: [
              {
                id: "menu.mensalidades",
                title: "Mensalidades",
                to: { name: "mensalidades" },
                permissions: "financeiro.baixarParcela",
                icon: "",
              },
              {
                id: "menu.gestao_caixas",
                title: "Gestão de Caixas",
                to: { name: "caixas" },
                permissions: "caixas.abrir",
                icon: "",
              },
            ],
          },
          {
            id: "menu.administracao",
            icon: "mdi-account-network",
            title: "Administração",
            exibir: true,
            children: [
              {
                id: "menu.franquias",
                title: "Franquias",
                to: { name: "franquias" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              {
                id: "menu.circuito_notas",
                title: "Circuito De Notas",
                to: { name: "circuito-notas" },
                permissions: ["circuitoNotas.*"],
                icon: "",
              },
              {
                id: "menu.bolsa_familia",
                title: "Bolsa Família",
                to: { name: "bolsa-familia" },
                permissions: ["bolsaFamilia.*"],
                icon: "",
              },
              {
                id: "menu.calculadora_fundeb",
                title: "Calculadora FUNDEB",
                to: { name: "fundeb.calculadora" },
                permissions: ["franquias.*"],
                exibir: this.user.roleName === "admin" || this.user.roleName === "super-admin",
                icon: "",
              },
            ],
          },
          {
            id: "menu.calendario_letivo",
            icon: "mdi mdi-calendar-check",
            title: "Calendário Letivo",
            exibir: !(
              (this.user ? this.user.roleName : "") === "coordenador" ||
              (this.user ? this.user.roleName : "") === "professor"
            ),
            children: [
              {
                id: "menu.calendario_letivo.calendario",
                title: "Calendário",
                to: { name: "calendario-letivo.create" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              {
                id: "menu.calendario_letivo.adicionar_categoria",
                title: "Adicionar Categoria",
                to: { name: "eventos-calendario-letivo" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.notifiq",
            icon: "mdi-bell-ring",
            title: "Notifiq",
            exibir: true,
            children: [
              {
                id: "menu.notifiq.presenca",
                title: "Presença no Notifiq",
                to: { name: "notifiq.indexNotifiq" },
                // permissions: ["notifiq.listaPresencasNotifiq"],
                icon: "",
              },
            ],
          },
          // {
          //   icon: "fa fa-bell",
          //   title: "Avisos",
          //   exibir: true,
          //   children: [
          //     {
          //       title: "Ver todos",
          //       to: { name: "avisos.listar" },
          //       permissions: ["franquias.*", "franquias.criarFranquia"],
          //       icon: "",
          //     },
          //   ],
          // },
          {
            id: "menu.ajuda_tutorial",
            icon: "mdi-help",
            title: "Ajuda e tutorial",
            exibir: true,
            children: [
              {
                id: "menu.tutoriais",
                title: "Tutoriais",
                href: "https://epublic.tawk.help/",
                target: "_blank",
              },
              // {
              //   title: "Fale conosco",
              //   href: "https://tawk.to/caju",
              //   target: "_blank",
              // },
            ],
          },
        ],
        width: "250px",
      };
    },
  },
  mounted() {
    // this.$Tawk.$setOnLoadFunction(() => this.$Tawk.$showWidget());
  },
  data() {
    return {
      selectedItem: 0,
      openAtualizarSenhaModal: false,
      openSelecionarFranquiaModal: false,
      exibirFinanceiro,
    };
  },
  methods: {
    toggleMenu() {
      this.$store.commit("MainTemplate/setMenuOpen", !this.menuOpen);
    },
  },
};
</script>
